<ng-container *ngIf="public_form_hash">
    <edit-component [IS_IFRAME_MODE]="true" [IS_EMBED_MODE]="true" [filter_id]="filter_id" [public_form_hash]="public_form_hash" [public_form_rid]="rid"></edit-component>
</ng-container>
